function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import FilePickerSource from './file-picker-source';
import { LinkOutlined } from '@ant-design/icons';
var TYPE = 'url';

// tslint:disable-next-line:function-name
function UrlSource(props) {
  return /*#__PURE__*/React.createElement(FilePickerSource, _extends({}, props, {
    type: TYPE
  }));
}
UrlSource.type = TYPE;
UrlSource.defaultLabel = 'Link (URL)';
UrlSource.defaultIcon = /*#__PURE__*/React.createElement(LinkOutlined, null);
export default UrlSource;